import Link from "next/link";
import SafeEmailText from "@/components/common/SafeEmailText";

type ContactContentItem = {
  id: number;
  title: string;
  action: string;
  text?: string;
  email?: string;
  isEmail?: boolean;
};

const ContactInfo = () => {
  const contactContent: ContactContentItem[] = [
    {
      id: 1,
      title: "Toll Free Customer Care",
      action: `tel:${process.env.NEXT_PUBLIC_ADMIN_CONTACT}`,
      text: process.env.NEXT_PUBLIC_ADMIN_CONTACT,
    },
    {
      id: 2,
      title: "Need live support?",
      action: "/contact",
      isEmail: true,
      email: process.env.NEXT_PUBLIC_ADMIN_EMAIL,
    },
  ];

  return (
    <>
      {contactContent.map((item) => (
        <div className="mb-20" key={item?.id}>
          <div className={"text-14"}>{item?.title}</div>
          {item?.isEmail ? (
            <Link href={item?.action} className="text-18 fw-500 text-dark-1 mt-5">
              <SafeEmailText email={item.email} />
            </Link>
          ) : (
            <a href={item?.action} className="text-18 fw-500 text-dark-1 mt-5">
              {item?.text}
            </a>
          )}
        </div>
      ))}
    </>
  );
};

export default ContactInfo;
